<!-- Wrapper-->
<div id="wrapper">
  <!-- Left navigation bar -->
  <tig-navigation></tig-navigation>
  <!-- Main page wrapper -->
  <div id="page-wrapper" class="gray-bg">
    <!-- Top navigation -->
    <tig-topnavbar></tig-topnavbar>
    <!-- Main view/routes wrapper-->
    <router-outlet></router-outlet>
    <!-- Footer -->
    <tig-footer></tig-footer>
  </div>
  <!-- End page wrapper-->
</div>
<!-- End wrapper-->